module.exports = __webpack_public_path__ + "img/logo-text-on-dark.f5191519.svg";